import { useLocation } from "react-router";

export type FlowType = "web" | "olb";

export function useFlowType(): FlowType {
  const location = useLocation();

  // Check if the current path starts with /olb-
  const pathSegments = location.pathname.split("/").filter(Boolean);
  if (pathSegments[0]?.startsWith("olb-")) {
    return "olb";
  }

  return "web";
}
